import { Widget, WidgetOptions } from './widget';

declare global {
  interface Window {
    ApiDocsWidget: {
      init: (options: WidgetOptions) => Promise<Widget>;
    };
  }
}

// Capture script reference immediately (only available during initial execution)
const currentScript = document.currentScript as HTMLScriptElement | null;

// Auto-initialize from script tag data attributes
function autoInit(): void {
  if (!currentScript) return;

  const apiUrl = currentScript.dataset.apiUrl;
  const widgetId = currentScript.dataset.widgetId;

  if (apiUrl && widgetId) {
    window.ApiDocsWidget.init({ apiUrl, widgetId });
  }
}

// Export global API
window.ApiDocsWidget = {
  async init(options: WidgetOptions): Promise<Widget> {
    const widget = new Widget(options);
    await widget.init();
    return widget;
  },
};

// Auto-init when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInit);
} else {
  autoInit();
}

export { Widget, WidgetOptions };
